export default {
  GET_KARUNA_POINT(state, payload) {
    state.karunaPoint = payload;
  },
};
